import {Component, Vue} from 'vue-property-decorator'
import {getMarketClueFollowStatisticalData} from "@/api/common";
import {delNullProperty} from "@/utils";
import {formatDate} from "@/utils/timeFilter";
import MoreUsersFilter from "@/components/moreUsersFilter/index.vue";

@Component({
    components: {MoreUsersFilter}
})
export default class MarketFollowStatic extends Vue {
    tableData = []
    page = 1
    total = 0
    id: string;
    loading = false
    pageSize = 20
    timer = null
    userIdList = []
    marketClueName = ''
    filter_createdStartAt = ''


    created() {
        this.id = String(this.$route.query.id)
        this.getTableData()
    }

    get createdAt() {
        let str = ''
        if (this.filter_createdStartAt && this.filter_createdStartAt.length > 0) {
            str = formatDate('yyyy-MM-dd', new Date(this.filter_createdStartAt[0])) + '&' + formatDate('yyyy-MM-dd', new Date(this.filter_createdStartAt[1]))
        }
        return str
    }

    async getTableData() {
        this.loading = true
        const data: any = await getMarketClueFollowStatisticalData(delNullProperty({
            marketClueName: this.marketClueName,
            createdAt: this.createdAt,
            userIdList: this.userIdList,
            limit: this.pageSize,
            page: this.page
        }))

        this.total = data.allNum
        this.tableData = data.marketClueFollowList
        this.loading = false
    }


    pageChange(page: number) {
        if (this.timer !== null) clearTimeout(this.timer)
        this.timer = setTimeout(() => {
            this.page = page
            this.getTableData()
        }, 1000)
    }

    pageSizeChange(val: number) {
        this.pageSize = val
        this.getTableData()
    }


    changefilterDuty(e) {
        this.userIdList = e.id
        if (this.timer !== null) clearTimeout(this.timer)
        this.timer = setTimeout(() => {
            this.page = 1
            this.getTableData()
        }, 1000)
    }
}
